import { useDateFormat } from '@vueuse/core'

export default function (date?: Date) {
  const articleDateFormat = useDateFormat(date, 'DD.MM.YYYY')
  const nowFormat = useDateFormat(useNow(), 'YYYY-MM-DD HH:mm:ss')

  return {
    articleDateFormat,
    nowFormat
  }
}
